import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import ProgressBar from "../ProgressBar";

export default function FreeCourseCard({ item, handleEnroll }) {
    const navigate = useNavigate();
    const viewPage = () => {
        navigate(`/free-courses/${item.id}`);
    };

    return (
        <MainDiv>
            <TopPart key={item.id} onClick={viewPage}>
                <ImageTag src={item.image} />
                {/* <RatingDiv>
                    <RatingNum>4.6</RatingNum>
                    <Star src={star} alt="icon" />
                </RatingDiv> */}
            </TopPart>
            <BottomPart>
                <BottomContainer>
                    <TechnologyText>{item.category_data?.name}</TechnologyText>
                    {item?.enrolled === false ? (
                        <EnrollNowText
                            onClick={() => {
                                handleEnroll(item.id);
                            }}
                        >
                            Enroll Now
                        </EnrollNowText>
                    ) : (
                        <EnrollNowText
                            onClick={() => {
                                viewPage();
                            }}
                        >
                            Watch Now
                        </EnrollNowText>
                    )}
                </BottomContainer>
                <SubjectTitleText>{item.title}</SubjectTitleText>
                <InstructorContainer>
                    <InstructorImgContainer>
                        <img
                            src={item?.instructor_data?.image}
                            alt="instructor_image"
                        />
                    </InstructorImgContainer>
                    <InstructorDetials>
                        <SmallText>Instructor</SmallText>
                        <Text>{item?.instructor_data?.name}</Text>
                    </InstructorDetials>
                </InstructorContainer>
                <Detials>
                    <Paragarph fontSize="14px" color="#9D9D9D" fontWeight="400">
                        {item?.description.slice(0, 120)}
                    </Paragarph>
                </Detials>
                <EnrollNowWrapper>
                    {item?.enrolled === false ? (
                        <></>
                    ) : (
                        <>
                            <Container>
                                <ProgressBarContainer>
                                    <ProgressBar
                                        current={item.progress}
                                        total="100"
                                        type="programCard"
                                    />
                                </ProgressBarContainer>
                            </Container>
                        </>
                    )}
                </EnrollNowWrapper>
            </BottomPart>
        </MainDiv>
    );
}

const MainDiv = styled.div`
    background: #fff;
    padding: 15px;
    border: 1px solid #e5e5e5;
    border-radius: 10px;
    height: 470px;
    width: 100%;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
    &:hover {
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.08);
        transform: translateY(-2px);
    }
`;
const TopPart = styled.div`
    margin-bottom: 10px;
    border-radius: 6px;
    width: 100%;
    height: 180px;
    cursor: pointer;
    overflow: hidden;
`;
const ImageTag = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 6px;
    object-fit: cover;
    transition: transform 0.3s ease;
    &:hover {
        transform: scale(1.05);
    }
`;
const RatingDiv = styled.div`
    position: absolute;
    bottom: 10%;
    right: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 20px;
    padding: 5px 7px;
`;
const RatingNum = styled.h6`
    color: #000000;
    font-size: 0.72rem;
    margin-right: 5px;
`;
const Star = styled.img``;
const BottomPart = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;
const TechnologyText = styled.span`
    border: 1px solid #cdd5df;
    text-transform: capitalize;
    background: #ffffff;
    font-size: 12px;
    font-weight: bold;
    color: #364152;
    padding: 4px 10px;
    border-radius: 5px;
`;

const BottomContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
`;

const SubjectTitleText = styled.h4`
    font-size: 0.94rem;
    font-weight: 500;
    text-transform: capitalize;
    color: #010101;
    font-weight: bold;
    height: 40px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;
const EnrollNowWrapper = styled.div`
    margin-top: 10px;
    display: flex;
    align-items: center;
    transition: 0.5s;
    &:hover {
        /* box-shadow: 0 0.5em 0.5em -0.4em var(--hover); */
        transform: translateY(-0.05em);
    }
`;
const EnrollNowText = styled.h6`
    color: #ffffff;
    font-size: 0.85rem;
    cursor: pointer;
    background: #522f91;
    border-radius: 8px;
    padding: 8px 10px;
    font-weight: bold;
`;

const Container = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`;
const ProgressBarContainer = styled.div`
    width: 100%;
`;

const InstructorContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    margin: 10px 0;
`;

const InstructorDetials = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const InstructorImgContainer = styled.div`
    width: 45px;
    height: 45px;
    border-radius: 50%;
    overflow: hidden;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;
const Detials = styled.div`
    width: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
`;

const SmallText = styled.h3`
    font-size: 0.8rem;
    font-weight: 400;
    color: #9d9d9d;
`;

const Text = styled.h4`
    font-size: 1rem;
    font-weight: 500;
    color: #010101;
`;
const Paragarph = styled.p`
    font-size: 0.8rem;
    font-weight: 400;
    color: #9d9d9d;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;
